import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";

import {User} from "@/interfaces/user";

import {AxiosResponse} from "axios";
import {$http} from "@/main";
import router from "@/router";
import {clearAllHttpErrors, IPxError, processReason} from "@/lib/util/errors";
import {createDefaultUser} from "@/lib/createNew/user";

@Module({
  // store: store,
  // dynamic: true,
  name: "user",
  namespaced: true,
})
export default class UserStore extends VuexModule {
  token: string | null = null;

  user: User = createDefaultUser();

  /*
   A central location for http httpErrors to go
   */
  httpErrors: IPxError[] = [];

  @Mutation
  pushHttpErrors(reason: { response: AxiosResponse }) {
    this.httpErrors = processReason(reason);
  }

  @Mutation
  pushError(error: IPxError) {
    this.httpErrors.push(error);
  }

  @Mutation
  clearErrors() {
    this.httpErrors = [];
  }

  get userIsLoggedIn(): boolean {
    return (
      this.token !== null
      && this.token !== undefined
      && this.token !== ""
      && this.user !== null
      && this.user !== undefined
    );
  }


  @Action
  isUserLoggedIn() {
    return localStorage.token !== null;
  }

  get $http() {
    return this.context.rootState.$http;
  }

  @Mutation
  setLoggedInUser(loginData: { user: User, token: string }) {
    this.user = loginData.user;
    this.token = loginData.token;
  }

  @Mutation
  setUser(user: User) {
    this.user = user;
  }

  @Mutation
  setLoggedOut() {
    this.token = null;
    this.user = createDefaultUser();
    clearAllHttpErrors();
    router.push("/");
  }

  @Action({rawError: true})
  login(credentials: { email: string, password: string }) {

    return $http.post("login", {
      email: credentials.email,
      password: credentials.password,
    }).then((response) => {
      this.setLoggedInUser(response.data);
      return response;
    }).catch((reason) => {
      this.pushHttpErrors(reason);
      return false;
    });
  }

  @Action({rawError: true})
  createUser(user: User) {
    return $http.post("newUser", user).catch((reason) => this.pushHttpErrors(reason));
  }

  @Action({rawError: true})
  reloadUser() {
    $http.get("user").then(u => {
      this.setUser(u.data);
    });
  }
}
